import { createTriggerStore } from "@utils/createTriggerStore";
import { EditionEnrollmentTriggerPayload } from "./types";

const store = createTriggerStore<EditionEnrollmentTriggerPayload>();

export const openEditionEnrollmentModal = store.open;
export const closeEditionEnrollmentModal = store.close;
export const useEditionEnrollmentTrigger = store.useTrigger;
